import React from 'react';

const ProgressBar = ({ progress, label = 'Uploading...', showLabel = true, className = '' }) => {
    // Ensure progress is between 0 and 100
    const validProgress = Math.min(Math.max(progress, 0), 100);

    return (
        <div className={`w-full ${className}`}>
            {showLabel && (
                <div className="flex justify-between items-center mb-2">
                    <span className="text-sm font-medium text-blue-700">{label}</span>
                    <span className="text-sm font-medium text-blue-700">{Math.round(validProgress)}%</span>
                </div>
            )}
            <div className="relative w-full h-3 bg-gray-200 rounded-full overflow-hidden">
                {/* Background shimmer effect */}
                <div className="absolute top-0 left-0 w-full h-full bg-gray-200"></div>

                {/* Progress fill with gradient and animation */}
                <div
                    className="absolute top-0 left-0 h-full bg-gradient-to-r from-blue-500 via-blue-600 to-indigo-600 rounded-full transition-all duration-1000 ease-out shadow-[0_0_10px_rgba(59,130,246,0.5)]"
                    style={{ width: `${validProgress}%` }}
                >
                    {/* Shimmer overlay animation */}
                    <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full animate-[shimmer_1.5s_infinite]"></div>
                </div>
            </div>
        </div>
    );
};

export default ProgressBar;
